import { createFileRoute } from "@tanstack/react-router";
import { SinceCalculator } from "@/components/tools/SinceCalculator";

export const Route = createFileRoute("/tools/hari-menikah")({
  head: () => ({
    meta: [
      { title: "Kalkulator Hari Menikah - Sudah Berapa Lama Pernikahan?" },
      { name: "description", content: "Hitung sudah berapa lama kamu menikah. Hasil dalam tahun, bulan, hari, lengkap dengan weton tanggal akad." },
      { property: "og:title", content: "Kalkulator Hari Menikah" },
      { property: "og:description", content: "Sudah berapa lama menikah dengan pasangan? Cek di sini." },
    ],
  }),
  component: () => (
    <SinceCalculator
      title="Kalkulator Lama Menikah"
      intro="Sudah berapa lama kamu menikah dengan pasangan? Masukkan tanggal akad atau resepsi untuk tahu usia pernikahan kamu."
      dateLabel="Tanggal pernikahan"
      verb="menikah"
      iconKey="since-ring"
      storageKey="menikah"
      path="/tools/hari-menikah"
      body={[
        { heading: "Apa itu kalkulator lama menikah?", text: "Alat untuk menghitung usia pernikahan secara akurat. Cocok dipakai saat merencanakan anniversary, reuni keluarga, atau sekadar mengingat momen indah pernikahan." },
        { heading: "Cara menghitung", text: "Pilih tanggal akad/resepsi. Kami hitung total hari sampai hari ini, plus pecah jadi tahun-bulan-hari serta weton tanggal pernikahan menurut kalender Jawa." },
        { heading: "Anniversary makin bermakna", text: "Bagikan link hasil ke pasangan, atau jadikan reminder personal. Kalkulator ini juga membantu hitung kapan tepat 1000 hari, 5 tahun, 10 tahun pernikahan." },
      ]}
      faq={[
        { q: "Tanggal mana yang dipakai - akad atau resepsi?", a: "Bebas. Kebanyakan orang pakai tanggal akad/sah sebagai patokan utama." },
        { q: "Apakah saya bisa simpan dua tanggal?", a: "Saat ini kalkulator menyimpan satu tanggal. Untuk kombinasi lain, pakai Kalkulator Hari." },
        { q: "Ada tampilan jam atau menit?", a: "Ya. Selain tahun-bulan-hari, kami tampilkan total minggu, jam, dan menit pernikahan." },
        { q: "Bagaimana cara membagikan ke pasangan?", a: "Klik 'Bagikan hasil'. Link yang disalin sudah berisi tanggal pernikahan, jadi pasangan langsung lihat angka yang sama." },
        { q: "Apa weton hari pernikahan penting?", a: "Dalam tradisi Jawa, weton sering dijadikan referensi. Kami tampilkan sebagai informasi tambahan." },
      ]}
    />
  ),
});